<template>
    <el-scrollbar wrap-class="scrollbar-wrapper">
       <el-menu
        :default-active="'/' + this.$route.path.split('/')[1]"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        mode="vertical"
        @select="handleSelect"
       >
          <sidebar-item v-for="route in permission_routers" :key="route.path" :item="route" :base-path="route.path" />
       </el-menu>
    </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import variables from '@/styles/variables.scss'
import SidebarItem from './SidebarItem'
export default {
  props: ["reload"],
  components: { 
    SidebarItem
   },
  computed: {
    ...mapGetters([
      'permission_routers'
    ]),
    variables() {
      return variables
    },
  },
  methods: {
    handleSelect(i,e){
      this.reload()
      // console.log(e)
      // console.log(i)
      // console.log(111)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue